import {HttpService} from "./http";

class FilesService extends HttpService {
    public constructor() {
        super("/client-app/client/files");
    }

    public index(filters: string | object | null = null, options: Record<string, any> = {}): Promise<any> {
        return this.http
            .get(`${this.route}/`, {
                params: filters,
                ...options,
            })
            .then(this.handleResponse.bind(this))
            .catch(this.handleError.bind(this));
    }

    public getFile(id: number): Promise<any> {
        return this.http
            .get(this.route + "/get/" + id)
            .then(this.handleResponse.bind(this))
            .catch(this.handleError.bind(this));
    }

    public viewedByClient(userId: number, fileResourceId: number): Promise<any> {
        return this.http
            .post(`${this.route}/${userId}/viewed/${fileResourceId}`)
            .then(this.handleResponse.bind(this))
            .catch(this.handleError.bind(this));
    }

    public stats(options: Record<string, any> = {}): Promise<any> {
        return this.http
            .get(`${this.route}/stats`, { ...options })
            .then(this.handleResponse.bind(this))
            .catch(this.handleError.bind(this));
    }
    
    public getRecentFiles(): Promise<any> {
        return this.http
            .get(`${this.route}/recent`)
            .then(this.handleResponse.bind(this))
            .catch(this.handleError.bind(this));
    }

    public store(formData: FormData): Promise<any> {
        return this.http
            .post(this.route, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then(this.handleResponse.bind(this))
            .catch(this.handleError.bind(this));
    }   
    
    public getFolderTags(options: Record<string, any> = {}): Promise<any> {
        return this.http
            .get(`${this.route}/tags`, { ...options })
            .then(this.handleResponse.bind(this))
            .catch(this.handleError.bind(this));
    }
}

export const filesService: FilesService = new FilesService();
